import { SolutionComponent, SolutionSaveResult, SolutionSaveResultType } from './../dialogs/solution/solution.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Environment, Solution, SolutionInfo } from 'src/app/model/SolutionInfo';
import { UploadFileType } from 'src/app/model/Upload';
import { UserInfo } from 'src/app/model/User';
import { FileSizePipe } from 'src/app/pipe/file-size.pipe';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { EventService } from 'src/app/service/event.service';
import { SolutionService } from 'src/app/service/solution.service';
import { Utils } from 'src/app/utils';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { ColumnSort, ColumnType, DataTableColumn, DataTableColumnFilter, DataTableFilter, DataTableRow, FilterType } from '../controls/datatable/datatable.component';
import { ModalControl, ModalControlType, ModalMessageComponent, ModalMessageType, ModalResult } from '../controls/modal-message/modal-message.component';
import { Modal } from '../controls/modal/modal.service';
import { PageCount, PageEvent } from '../controls/pagination/pagination.component';
import { DragDropComponent } from '../dialogs/drag-drop/drag-drop.component';
import { FormMode, FormObjectType } from '../solution-form/solution-form.component';
import { Events, MsgPayLoad } from 'src/app/service/websocket.service';

@Component({
    selector: 'app-settings-solutions',
    templateUrl: './settings-solutions.component.html',
    styleUrls: ['./settings-solutions.component.css'],
    standalone: false
})
export class SettingsSolutionsComponent implements OnInit {

  title: string = $localize`Solutions`;
  cols: DataTableColumn[] = [];
  rows: DataTableRow[] = [];
  loading: boolean = true;
  total: number = 0;
  currentPage: number = 1;
  solutionInfo: SolutionInfo = new SolutionInfo();
  filters: DataTableFilter[] = [];
  height: string = 'calc(100vh - 200px)';
  sortField: string = 'name';
  sortDirection: ColumnSort = ColumnSort.DESC;
  envSortField: string = 'name';
  envSortDirection: ColumnSort = ColumnSort.DESC;

  solutions: Solution[] = [];
  environments: Environment[] = [];
  totalEnvCount: number = 0;
  exporting: boolean = false;
  currentUser: UserInfo;
  isSuperUser: boolean = false;
  isAdminUser: boolean = false;
  isSolutionManager: boolean = false;
  canImport: boolean = false;
  canExport: boolean = false;
  canAddSolution: boolean = false;
  canDeleteSolution: boolean = false;
  canEditSolution: boolean = false;
  canDeleteEnv: boolean = false;
  canAddEnv: boolean = false;
  canSync: boolean = false;

  showEnvironments: boolean = false;
  showImportSolution: boolean = false;
  importData: any;
  FormMode = FormMode;
  selectedSolution: Solution;
  selectedEnvironment: Environment;
  mode: FormMode = FormMode.ADD;
  type: FormObjectType;

  solutionPageInfo: PageEvent;
  environmentPageInfo: PageEvent;

  envTitle: string = "Environments";
  envRows: DataTableRow[] = [];
  envCols: DataTableColumn[] = [];

  FormObjectType = FormObjectType;

  filterValue: string;

  //subscription
  solutionInfoSubscription: Subscription;
  eventMessageSubscription: Subscription;

  constructor(private eventService: EventService,
    private authSrv: AuthenticationService,
    private solutionSrv: SolutionService,
    private modal: Modal,
    protected router: Router,
    public route: ActivatedRoute) {

    this.cols = Array<DataTableColumn>(
      new DataTableColumn("name", $localize`Name`, ColumnType.STRING, true, "18", ColumnSort.DESC, undefined,
        new DataTableColumnFilter(FilterType.STRING)),
      new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "18"),
      new DataTableColumn('envCount', $localize`Environments`, ColumnType.STRING, false, "10"),
      new DataTableColumn("createdBy", $localize`Created By`, ColumnType.STRING, false, "12.5"),
      new DataTableColumn("createdDate", $localize`Created Date`, ColumnType.DATE, false, "14.5"),
      new DataTableColumn("updatedBy", $localize`Updated By`, ColumnType.STRING, false, "12.5"),
      new DataTableColumn("updatedDate", $localize`Updated Date`, ColumnType.DATE, false, "14.5")
    );

    this.envCols = Array<DataTableColumn>(
      new DataTableColumn("name", $localize`Name`, ColumnType.STRING, true, "23", ColumnSort.DESC, undefined,
        new DataTableColumnFilter(FilterType.STRING)),
      new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "23"),
      new DataTableColumn("createdBy", $localize`Created By`, ColumnType.STRING, false, "12.5"),
      new DataTableColumn("createdDate", $localize`Created Date`, ColumnType.DATE, false, "14.5"),
      new DataTableColumn("updatedBy", $localize`Updated By`, ColumnType.STRING, false, "12.5"),
      new DataTableColumn("updatedDate", $localize`Updated Date`, ColumnType.DATE, false, "14.5")
    );

    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.solutionInfo = newSolutionInfo;
    });

    this.currentUser = this.authSrv.getLoggedInUser();
    this.isSuperUser = Utils.isSuperuserRole(this.currentUser);
    this.isAdminUser = Utils.isAdminRole(this.currentUser);
    this.isSolutionManager = Utils.isSolutionManagerRole(this.currentUser);
  }

  ngOnInit(): void {
    this.solutionPageInfo = new PageEvent(1, 0, PageCount.TWENTYFIVE);
    this.getSolutions(false);
  }

  ngOnDestroy() {
    if(this.solutionInfoSubscription !== undefined){
      this.solutionInfoSubscription.unsubscribe();
    }
    if(this.eventMessageSubscription !== undefined){
      this.eventMessageSubscription.unsubscribe();
    }
  }

  getSolutions(reloadEnvs: boolean) {
    let tmpSolutions: Solution[] = [];

    this.loading = true;
    this.solutionSrv.getSolutions().pipe(
      tap(resp => {
        let numValidSol:number = 0;
        this.totalEnvCount = 0;

        resp.body.forEach(sol => {
          sol.envCount = (sol.environments == undefined) ? 0 : sol.environments.length;
          this.totalEnvCount += sol.envCount;
          if (this.selectedSolution !== undefined && this.selectedSolution.name == sol.name) {
            this.selectedSolution = sol;
          }
          tmpSolutions.push(sol);
          if(sol.envCount > 0){
            numValidSol++;
          }
        });

        this.canImport = (this.isSuperUser || this.isAdminUser);
        this.canExport = (this.isSuperUser || this.isAdminUser);
        this.canAddSolution = (this.isSuperUser || this.isAdminUser);
        this.canDeleteSolution = ((this.isSuperUser || this.isAdminUser) && numValidSol > 1);
        this.canEditSolution = (this.isSuperUser || this.isAdminUser || this.isSolutionManager);
        this.canDeleteEnv = ((this.isSuperUser || this.isAdminUser || this.isSolutionManager) && this.totalEnvCount > 1);
        this.canAddEnv = (this.isSuperUser || this.isAdminUser || this.isSolutionManager);;
        this.canSync = (this.totalEnvCount > 1);

        if (reloadEnvs) {
          this.showEnvironmentInfo(this.selectedSolution);
        }

        if (tmpSolutions.length > 0) {
          this.solutions = tmpSolutions;
          this.sortData();
        } else {
          this.solutions = [];
          this.rows = [];
        }
      }),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe();
  }

  onPageChange(pageEvent: PageEvent) {
    this.setSolutionPage(pageEvent);
  }

  sortSolutions(col: DataTableColumn) {
    this.sortField = col.field;
    this.sortDirection = col.sortDirection;
    this.sortData();
  }

  sortData() {
    this.solutions.sort((a, b) => (a[this.sortField].toLowerCase() > b[this.sortField].toLowerCase() ? (this.sortDirection == ColumnSort.DESC) ? 1 : -1 :
      (this.sortDirection == ColumnSort.DESC) ? -1 : 1));
    this.setSolutionPage(this.solutionPageInfo);
  }

  setSolutionPage(pageEvent: PageEvent) {
    let tmpSolutions: DataTableRow[] = [];
    let filteredSolutions: Solution[] = this.solutions;

    if(pageEvent.startingIndex >= this.solutions.length){
      if(pageEvent.pagenum > 1){
        pageEvent.pagenum--;
      }
      if(pageEvent.startingIndex > 0){
        pageEvent.startingIndex -= pageEvent.itemsPerPage;
      }
    }
    if(this.filterValue !== undefined && this.filterValue !== ""){
      let tmpFilteredSolutions: Solution[] = [];
      filteredSolutions.forEach(solution =>{
        if (solution.name.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1){
          tmpFilteredSolutions.push(solution);
        }
      });
      filteredSolutions = tmpFilteredSolutions;
    }
    for (let i = pageEvent.startingIndex; i < filteredSolutions.length; i++) {
      if (tmpSolutions.length < pageEvent.itemsPerPage) {
        let sol = filteredSolutions[i];
        let agentCount: number = 0;
        let productCount: number = 0;

        sol.environments.forEach(env =>{
          agentCount += env.agents.length;
          env.agents.forEach(agent =>{
            productCount += agent.products.length;
          });
        });

        let menuItems: ActionMenuItem[] = [new ActionMenuItem("Environment", $localize`Environment`, ActionMenuIcon.LIST, sol, false)];
        if (this.canEditSolution) {
          menuItems.push(new ActionMenuItem("Edit", $localize`Edit`, ActionMenuIcon.EDIT, sol, false));
        }
        if (this.canDeleteSolution || ((this.isSuperUser || this.isAdminUser) && sol.envCount == 0)) {
          menuItems.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, sol, false));
        }
        if (this.canExport && sol.envCount > 0) {
          menuItems.push(new ActionMenuItem("Export", $localize`Export`, ActionMenuIcon.DOWNLOAD, sol, false));
        }
        if (this.canSync && sol.envCount > 0 && agentCount > 0 && productCount > 0) {
          menuItems.push(new ActionMenuItem("Sync", $localize`Synchronize`, ActionMenuIcon.SHARE, sol, false));
        }

        tmpSolutions.push(new DataTableRow(sol, menuItems, (sol.envCount == 0)));
      } else {
        break;
      }
    }

    this.total = filteredSolutions.length;
    this.rows = tmpSolutions;
    this.solutionPageInfo = pageEvent;
    this.currentPage = this.solutionPageInfo.pagenum;
  }


  solutionActionMenuClicked(event: ActionMenuEvent): void {
    switch (event.name) {
      case "Edit":
        this.editSolution(event.data[0]);
        break;
      case "Delete":
        this.deleteSolution(event.data[0]);
        break;
      case "Environment":
        this.showEnvironmentInfo(event.data[0]);
        break;
      case "Export":
        this.exportSolution(event.data[0]);
        break;
      case "Sync":
        this.router.navigate(['/settings/solutions/sync']);
        break;
    }
  }

  environmentActionMenuClicked(event: ActionMenuEvent): void {
    switch (event.name) {
      case "Edit":
        this.editEnvironment(event.data[0]);
        break;
      case "Delete":
        this.deleteEnvironment(event.data[0]);
        break;
    }
  }

  showAddSolutionDialog(): void {
    this.mode = FormMode.ADD;
    this.type = FormObjectType.SOLUTION;
    this.selectedSolution = undefined;
    this.selectedEnvironment = undefined;
    this.showDialog('otsc-settings-solutions-add-dialog', '425px');
  }

  editSolution(solution: Solution) {
    this.selectedSolution = solution;
    this.mode = FormMode.EDIT;
    this.type = FormObjectType.SOLUTION;
    this.showDialog('otsc-settings-solutions-edit-dialog', '425px');
  }

  showDialog(id:string, height:string): void {
    const sub: Subscription =
      this.modal.open(SolutionComponent, {
        data: {
          mode: this.mode,
          type: this.type,
          selectedSolution: this.selectedSolution,
          selectedEnvironment: this.selectedEnvironment
        },
        id: id
      }
      ).afterClosed.subscribe((result: SolutionSaveResult) => {
        if (result.type == SolutionSaveResultType.FAILURE) {
          let errMsg:string;
          if(this.mode == FormMode.ADD){
            if(this.type == FormObjectType.SOLUTION){
              errMsg = $localize`The server encountered an error while adding the new solution. Please try again later or contact your system administrator.`;
            }else if(this.type == FormObjectType.ENVIRONMENT){
              errMsg = $localize`The server encountered an error while adding the new environment. Please try again later or contact your system administrator.`;
            }
          }else if(this.mode == FormMode.EDIT){
            if(this.type == FormObjectType.SOLUTION){
              errMsg = $localize`The server encountered an error while updating the solution. Please try again later or contact your system administrator.`;
            }else if(this.type == FormObjectType.ENVIRONMENT){
              errMsg = $localize`The server encountered an error while updating the environment. Please try again later or contact your system administrator.`;
            }
          }
          let msg: MsgPayLoad = new MsgPayLoad(undefined, {
            message: errMsg
          });
          msg.setEvent(Events.ErrorMsg);
          Utils.addHeaderMessageBanner(this.eventService, msg);
        }

        let isEnv:boolean = (this.type == FormObjectType.ENVIRONMENT);

        if (result.type != SolutionSaveResultType.CANCEL) {
          this.getSolutions(isEnv);
        }
        this.showEnvironments = isEnv;
        sub.unsubscribe();
      });
  }

  deleteSolution(solution: Solution) {
    let systemCount: number = 0;
    solution.environments.forEach(env => {
      systemCount += env.agents.length;
    });
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Delete`,
          type: ModalMessageType.Question,
          message: $localize`There are ${solution.envCount} environment(s), ${systemCount} system(s), ${solution.userCount} user(s) and ${solution.logCount} log package(s) associated with this solution. Are you sure you want to remove? <br/><strong>Note:</strong> The systems will no longer be associated with this solution.`,
          primaryBtn: $localize`Delete`,
          secondaryBtn: $localize`Cancel`,
          width: '550px'
        },
        id: 'otsc-delete-solution-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          let success: boolean = false;
          this.loading = true;
          this.solutionSrv.deleteSolution(solution.name).pipe(
            tap(resp => {
              success = true;
              this.getSolutions(false);
            }),
            finalize(() => {
              if (!success) {
                this.loading = false;
              }
            })
          ).subscribe();
        }
        sub.unsubscribe();
      });
  }

  exportSolution(solution: Solution) {
    this.solutionSrv.getExportSolutionInfo(solution.name).pipe(
      tap(resp => {
        if (resp.body.status.success) {
          let exportInfo: any = resp.body.result.data;
          let totalSize: number = 0;
          let totalFileSize: string = "";
          let includeExtFiles: boolean = false;
          if (exportInfo.extVenFiles && exportInfo.extVenFiles.length > 0) {
            exportInfo.extVenFiles.forEach(extFile => {
              totalSize += extFile.byteSize;
            });
          }

          if (exportInfo.productFiles && exportInfo.productFiles.length > 0) {
            exportInfo.productFiles.forEach(productFile => {
              totalSize += productFile.totalSize;
            });
          }

          if (totalSize > 0) {
            totalFileSize = new FileSizePipe().transform(totalSize);
            includeExtFiles = true;
          }

          this.showExportMsg(exportInfo, totalFileSize, includeExtFiles);
        } else {
          this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Error`,
              type: ModalMessageType.Error,
              message: $localize`Unable to export solution. Please try again.`,
              primaryBtn: $localize`Close`,
              width: '350px'
            },
            id: 'otsc-export-solution-error-msg'
          });
        }
      })).subscribe();
  }

  showExportMsg(data: any, fileSize: string, includeExtFiles: boolean) {
    let fileCount = data.extVenFiles.length + data.productFiles.length;
    let checkControl: ModalControl = new ModalControl('export-include-files', ModalControlType.CHECKBOX,
      $localize`Include associated files. It requires at least ${fileSize} of disk space.`, true);
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Export solution`,
          type: ModalMessageType.Question,
          message: $localize`There are ${data.solution.environments.length} environment(s), ${data.deploymentPlans.length} plan(s), and ${fileCount} file(s) associated with this solution. Are you sure you want to export?`,
          primaryBtn: $localize`Export`,
          secondaryBtn: $localize`Cancel`,
          useResult: true,
          controls: (fileCount > 0) ? [checkControl] : [],
          width: '550px'
        },
        id: 'otsc-solution-export-msg'
      }).afterClosed.subscribe((result: ModalResult) => {
        if (result.isPrimary) {
          this.exporting = true;
          if (fileCount) {
            this.generateSolutionPackage(data.solution.name, result.controls[0].val);
          } else {
            this.generateSolutionPackage(data.solution.name, false);
          }
        }
        sub.unsubscribe();
      });
  }

  generateSolutionPackage(solution: string, includeFiles: boolean): void {

    this.solutionSrv.exportSolution(solution, includeFiles).pipe(
      tap(resp => {
        if (resp.body.status.success) {
          this.showExportPackageReady(resp.body.result.data.uId, resp.body.result.data.url);
        } else {
          let error: string = '';
          switch (resp.body.status.errorCode) {
            case 'ERROR_MK_STAGING_DIR_SOLUTION_PKG':
              error = $localize`Unable to create staging directory. Please try again.`;
              break;
            case 'ERROR_NO_DISKSPACE_SOLUTION_PKG':
              error = $localize`There is not enough disk space to generate solution package.`;
              break;
            default:
              error = $localize`Error generating solution package. Please try again.`;
              break;
          }
          this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Error`,
              type: ModalMessageType.Error,
              message: error,
              primaryBtn: $localize`Close`,
              width: '350px'
            },
            id: 'otsc-generate-solution-package-error-msg'
          });
        }
      }),
      finalize(() => {
        this.exporting = false;
      })
    ).subscribe();
  }

  showExportPackageReady(id: string, url: string): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Export solution`,
          type: ModalMessageType.Question,
          message: $localize`Solution package is ready for download. Click Download button and the solution package will be downloaded to your local file system.`,
          primaryBtn: $localize`Download`,
          secondaryBtn: $localize`Cancel`,
          width: '550px'
        },
        id: 'otsc-solution-export-ready-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          setTimeout(() => {
            window.open(url, "_self");
          }, 0);
        } else {
          this.solutionSrv.deleteExportCache(id).pipe(
            tap(resp => {
            })).subscribe();
        }
        sub.unsubscribe();
      });
  }

  onImportClick(): void {
    const sub: Subscription =
      this.modal.open(DragDropComponent, {
        data: {
          type: UploadFileType.SOLUTION,
          desc: $localize`Select or drop a file below to import a solution into System Center.`,
          supportMultiFiles: false
        },
        id: 'otsc-drag-drop-dialog',
        customclass: 'ot-modal-side-panel ot-modal-side-panel-md'
      }).afterClosed.subscribe((result: any) => {
        if (result.data !== undefined) {
          this.importData = result.data;
          this.showImportSolution = true;
        }
        sub.unsubscribe();
      });
  }

  onImportFormClose(imported: boolean) {
    this.importData = undefined;
    this.showImportSolution = false;
    this.getSolutions(false);
  }

  showEnvironmentInfo(solution: Solution): void {
    this.selectedSolution = solution;
    this.environments = this.selectedSolution.environments;
    this.sortEnvData(false);
    this.processEnvironmentRows();
    this.showEnvironments = true;
  }

  processEnvironmentRows(): void {
    let tmpRows: DataTableRow[] = [];
    this.environments.forEach(env => {
      let actionMenu: ActionMenuItem[] = [
        new ActionMenuItem("Edit", $localize`Edit`, ActionMenuIcon.EDIT, env, false)
      ];

      if (this.canDeleteEnv) {
        actionMenu.push(new ActionMenuItem("Delete", $localize`Delete`, ActionMenuIcon.DELETE, env, false));
      }
      tmpRows.push(new DataTableRow(env, actionMenu));

    });
    this.envRows = tmpRows;
  }

  backToSolutions(): void {
    this.showEnvironments = false;
    this.selectedSolution = undefined;
    this.envRows = [];
    this.getSolutions(false);
  }

  showAddEnvironmentDialog(): void {
    this.mode = FormMode.ADD;
    this.type = FormObjectType.ENVIRONMENT;
    this.showEnvironments = true;
    this.showDialog('otsc-settings-environments-add-dialog', '425px');
  }

  editEnvironment(environment: Environment): void {
    this.selectedEnvironment = environment;
    this.mode = FormMode.EDIT;
    this.type = FormObjectType.ENVIRONMENT;
    this.showEnvironments = true;
    this.showDialog('otsc-settings-environments-edit-dialog', '425px');
  }

  deleteEnvironment(environment: Environment): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Delete`,
          type: ModalMessageType.Question,
          message: $localize`There are ${environment.agents.length} system(s), ${environment.numUsers} user(s) and ${environment.logCount} log package(s) associated with this environment. Are you sure you want to remove? <br/><strong>Note:</strong> The systems will no longer be associated with this environment.`,
          primaryBtn: $localize`Delete`,
          secondaryBtn: $localize`Cancel`,
          width: '550px'
        },
        id: 'otsc-delete-environment-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.solutionSrv.deleteEnvironment(environment.id).pipe(
            tap(resp => {
              this.getSolutions(true);
            }),
            finalize(() => {
              this.loading = false;
            })
          ).subscribe();
        }
        sub.unsubscribe();
      });
  }

  onFilterChanged(event: any): void{
    this.filterValue = event.value;
    this.setSolutionPage(new PageEvent(1, 0, this.solutionPageInfo.itemsPerPage));
  }

  solutionRowClicked(event: any): void{
    this.showEnvironmentInfo(event.data);
  }

  sortEnvironments(col: DataTableColumn) {
    this.envSortField = col.field;
    this.envSortDirection = col.sortDirection;
    this.sortEnvData(true);
  }

  sortEnvData(refresh: boolean) {
    this.environments.sort((a, b) => (a[this.envSortField].toLowerCase() > b[this.envSortField].toLowerCase() ? (this.envSortDirection == ColumnSort.DESC) ? 1 : -1 :
      (this.envSortDirection == ColumnSort.DESC) ? -1 : 1));
    if(refresh){
      this.processEnvironmentRows();
    }
  }
}
